import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, View } from 'react-native';

export const Switcher: React.FC<{}> = () => {
  const { i18n } = useTranslation();

  return (
    <View>
      <Button
        onPress={() => i18n.changeLanguage('en')}
        title="en"
        disabled={i18n.language === 'en'}
      />
      <Button
        onPress={() => i18n.changeLanguage('ar')}
        title="ar"
        disabled={i18n.language === 'ar'}
      />
    </View>
  );
};
